import type { CreateUser, ShadowUser } from "@/models/user";

export const createUser = async (createUser: CreateUser): Promise<any> => {
  const url = `/api/onboarding/create-user`;
  try {
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(createUser),
    });
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`create user: ${error}`);
    throw error;
  }
};

export const checkShadowUser = async (
  debtorCorpExternalId: string,
): Promise<ShadowUser> => {
  const url = `/api/onboarding/shadow-user`;
  try {
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ debtorCorpExternalId }),
    });
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`check shadow user: ${error}`);
    throw error;
  }
};
